import { render, staticRenderFns } from "./ListGroupsModal.vue?vue&type=template&id=525e6b5f&scoped=true"
import script from "./ListGroupsModal.vue?vue&type=script&lang=js"
export * from "./ListGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./ListGroupsModal.vue?vue&type=style&index=0&id=525e6b5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e6b5f",
  null
  
)

export default component.exports